var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"rounded-lg shadow-lg object-cover object-center  w-full  lg:static lg:h-auto",attrs:{"src":_vm.imgSrc,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }